// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__-poIO","blue":"button_blue__rckd8","lightOrange":"button_lightOrange__2VGZA","rightArrow":"button_rightArrow__qrBu5"};